export class FileDownloader {
  static downloadTextFile(content, filename) {
    const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Limpiar el URL del blob
    URL.revokeObjectURL(url);
  }

  static generateFilename(type, projectName = "Proyecto") {
    const timestamp = new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:.]/g, "-");
    const reportType =
      type === "folder" ? "Informe_Carpetas" : "Estructura_Completa";
    return `${reportType}_${projectName}_${timestamp}.txt`;
  }
}
